// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"iSjS6":[function(require,module,exports,__globalThis) {
// Toggle visibility of fixed "All Projects" button based on the regular button's visibility.
// Uses IntersectionObserver when available, but also includes a scroll/resize fallback for robustness.
function initProjectBackButton() {
    const fixedButton = document.querySelector('.pd-back-button-fixed');
    const regularButton = document.querySelector('.project-details-content .pd-back-button:not(.pd-back-button-fixed)');
    if (!fixedButton) return;
    const showFixed = ()=>fixedButton.classList.add('is-visible');
    const hideFixed = ()=>fixedButton.classList.remove('is-visible');
    let rafId = null;
    const update = ()=>{
        rafId = null;
        // If we can't find the regular button, fall back to scroll position.
        if (!regularButton) {
            const y = document.scrollingElement && document.scrollingElement.scrollTop || window.scrollY || 0;
            if (y > 16) showFixed();
            else hideFixed();
            return;
        }
        const rect = regularButton.getBoundingClientRect();
        const viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
        const isVisible = rect.bottom > 0 && rect.top < viewportH;
        if (isVisible) hideFixed();
        else showFixed();
    };
    const requestUpdate = ()=>{
        if (rafId != null) return;
        rafId = window.requestAnimationFrame(update);
    };
    // Fallback updates (covers transformed layouts / edge browser cases)
    window.addEventListener('scroll', requestUpdate, {
        passive: true
    });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
    // Preferred observer
    if (regularButton && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries)=>{
            const entry = entries && entries[0];
            if (!entry) return;
            if (!entry.isIntersecting) showFixed();
            else hideFixed();
        }, {
            threshold: 0,
            rootMargin: '0px'
        });
        observer.observe(regularButton);
    }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProjectBackButton);
else initProjectBackButton();

},{}]},["iSjS6"], "iSjS6", "parcelRequire8c58", {})

//# sourceMappingURL=project-details-axis.b2cc062d.js.map
